// extracted by mini-css-extract-plugin
export default {"table":"Wrapper_table__s74-6","cell":"Wrapper_cell__H7f0r","container":"Wrapper_container__EcUng","logo":"Wrapper_logo__ZMvxu"};